import { FC, PropsWithChildren, useMemo, useState } from 'react';
import { Capacitor } from '@capacitor/core';

import {
	IPaymentEnvContext,
	PaymentEnvProvider,
	PaymentPostProcessor,
} from '@mopla/payment-flow';

import { environment } from '../environments/environment';

export const PaymentFeatureContainer: FC<PropsWithChildren> = ({
	children,
}) => {
	const [isNative] = useState(Capacitor.isNativePlatform());

	const paymentEnvValue = useMemo<IPaymentEnvContext>(
		() => ({
			trueLayerAuthLinkBase: isNative
				? environment.trueLayerAuthLinkNative
				: environment.trueLayerAuthLinkWeb,
			trueLayerRedirectUrl: isNative
				? environment.trueLayerDeepLink
				: environment.trueLayerRedirectUrl,
			enableOpenBankingEnv: environment.enableOpenBanking,
			stripeCustomCloseCallback: environment.stripeCustomCloseCallback,
			paymentBaseUrl: environment.paymentBaseUrl,
			stripeWebCallback: environment.stripeWebCallback,
			stripePublicKey: environment.stripePublicKey,
		}),
		[isNative]
	);

	return (
		<PaymentEnvProvider value={paymentEnvValue}>
			<PaymentPostProcessor />
			{children}
		</PaymentEnvProvider>
	);
};
